<template>
  <form class="form-horizontal">
    <div class="form-group">
      <label class="col-md-2 control-label">Format</label>
      <div class="col-md-10">
        <el-select class="select-primary"
                   v-model="type">
          <el-option class="select-primary"
                     value="csv"
                     label="CSV"/>
          <el-option class="select-primary"
                     value="xls"
                     label="Excel"/>
          <el-option class="select-primary"
                     value="json"
                     label="JSON"/>
        </el-select>
      </div>
    </div>
    <div class="form-group" style="margin-bottom: 0">
      <div class="col-md-1">
        <p-checkbox class="form-control-static" v-model="selectAll"/>
      </div>
      <label class="col-md-11 control-label" style="text-align: left">Select All</label>
    </div>
    <div class="form-group" style="margin-bottom: 0" v-for="(name, key) in displayColumns" :key="key">
      <div class="col-md-12">
        <div class="checkbox form-control-static">
          <input type="checkbox" v-model="selectedColumns" :value="key"/>
          <label>{{name}}</label>
        </div>
      </div>
    </div>
    <div class="text-right">
      <span v-show="processing">
      <i class="ti-reload ti-spin" style="font-size: large;"></i>
      {{processing}}
      </span>
      <button type="button" class="btn btn-default" :disabled="processing" @click="downloadData">
        {{i18n.fr('action.download')}}
      </button>
      <json-excel style="display: none"
                  ref="downloadButton"
                  :data="data"
                  :fields="fields_"
                  :type="type"
                  :name="'export.' + type"
                  :disabled="processing"/>
    </div>
  </form>
</template>

<script>
  import JsonExcel from 'vue-json-excel';
  import {filter, keyBy, difference} from 'lodash';

  export default {
    name: 'export-dialog',
    components: {
      JsonExcel,
    },
    props: {
      schema: Object,
      columns: Array,
      fields: Object,
      processRow: Function,
      $rootTable: Object,
    },
    data() {
      return {
        processing: false,
        // data: [{}],
        type: 'csv',
        selectedColumns: [],
        data: [],
      };
    },
    computed: {
      selectAll: {
        get() {
          return !(Object.keys(this.displayColumns).length - this.selectedColumns.length);
        },
        set(v) {
          this.selectedColumns = v ? Object.keys(this.displayColumns) : [];
        },
      },
      displayColumns() {
        return this.fields
          ? {...this.fields}
          : filter(this.columns, x => !x.hidden).reduce((acc, x) => {
            acc[x.prop] = x.label;
            return acc;
          }, {});
      },
      fields_() {
        return this.selectedColumns.reduce((acc, x) => {
          acc[this.displayColumns[x]] = x;
          return acc;
        }, {});
      },
    },
    methods: {
      async downloadData() {
        this.processing = '-';
        try {
          let data = [];
          let offset = 0;
          let total = 0;
          let extra = 0;
          let fields = this.displayColumns;
          while (true) {
            let response = await this.schema.list.call(
              this.$rootTable || this,
              {skip: offset, limit: 10, status: {$exists: true}});
            total = response.total;
            if (!response.data.length) {
              break;
            }
            if (typeof this.processRow === 'function') {
              data = data.concat(
                await Promise.all(
                  response.data.map(row =>
                    this.processRow.call(this.$rootTable || this, row, fields).then(x => {
                      ++offset;
                      if (Array.isArray(x) && x.length > 1) {
                        extra += x.length - 1;
                      }
                      this.processing = `${offset} / ${total} (${total + extra} rows)`;
                      return x;
                    }))));
            } else {
              data = data.concat(response.data);
              offset += response.data.length;
              this.processing = `${offset} / ${total} (${total + extra} rows)`;
            }
          }
          this.data = data.reduce((acc, x) => acc.concat(x), []);
          await true; // shortcut for Vue.$nextTick so this.data will be populated to the component
          if (this.type === 'json') {
            let json = this.$refs.downloadButton.getProcessedJson(this.data, this.fields_);
            this.$refs.downloadButton.export(JSON.stringify(json, null, '  '),
              this.$refs.downloadButton.name, "application/json");
          } else {
            this.$refs.downloadButton.generate();
          }
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
        this.processing = false;
      },
    },
    mounted() {
      this.selectedColumns = Object.keys(this.displayColumns);
      // utf8 BOM patch
      this.$refs.downloadButton.base64ToBlob = function (data, mime) {
        return new Blob(['\uFEFF', data], {type: mime});
      };
      this.$refs.downloadButton.jsonToCSV = function (data) {
        let quote = s => {
          s = s + '';
          if (s.match(/[,"\n]/)) {
            s = '"' + s.replace(/"/g, '""') + '"';
          }
          return s;
        };
        let csvData = '';
        if (this.title != null) {
          csvData += quote(this.title) + '\r\n';
        }
        for (let key in data[0]) {
          csvData += quote(key) + ',';
        }
        csvData = csvData.slice(0, csvData.length - 1);
        csvData += '\r\n';
        data.map(function (item) {
          for (let key in item) {
            csvData += quote(item[key]) + ',';
          }
          csvData = csvData.slice(0, csvData.length - 1);
          csvData += '\r\n';
        });
        return csvData;
      };
    },
  };
</script>



// WEBPACK FOOTER //
// ExportDialog.vue?1d2b5652